import script from "./ProductViewer_fbd.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductViewer_fbd.vue?vue&type=script&setup=true&lang=js"

import "./ProductViewer_fbd.vue?vue&type=style&index=0&id=7db3a30c&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db3a30c"]])

export default __exports__